import { isDevelopmentMode, methods, sendRequest } from "../base";

export const getCurrentGoldPrice = (commodity_id = 1) => {
  return sendRequest(
    isDevelopmentMode()
      ? `/gold/live-price?commodity_id=${commodity_id}`
      : "/trade/current-gold-price/"
  );
};

export const getGoldPriceHistory = (selectedChart = 1) => {
  return sendRequest(
    isDevelopmentMode()
      ? "/gold/price-history?commodity_id=" + selectedChart
      : "",
    methods.GET,
    {},
    {},
    "v2"
  );
};

export const getGoldBars = (commodity_id = 1) => {
  return sendRequest(
    isDevelopmentMode()
      ? "/gold/bars?commodity_id=" + commodity_id
      : "/trade/get-bar/"
  );
};

export const purchasePhysicalGold = (amount, bar, commodity_id) => {
  return sendRequest(
    isDevelopmentMode() ? "/gold/physical-gold" : "trade/physical-gold/",
    methods.POST,
    { quantity: amount, bar: bar, commodity: commodity_id }
  );
};
